document.addEventListener("DOMContentLoaded", () => {
  function equalizeNameTariffHeight() {
    const titleElements = document.querySelectorAll(".name-tariff");
    const sectionTitles = document.querySelectorAll(
      ".tariff-catalog .section__title"
    );
    const categoryTariffTitle = document.querySelector(
      ".tariff-catalog__title"
    );
    let maxHeight = 44;

    titleElements.forEach((el) => (el.style.height = "auto"));
    sectionTitles.forEach((el) => (el.style.height = "auto"));

    titleElements.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });
    sectionTitles.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    titleElements.forEach((el) => (el.style.height = `${maxHeight}px`));
    sectionTitles.forEach((el) => (el.style.height = `${maxHeight}px`));

    if (window.innerWidth <= 767) {
      if (categoryTariffTitle) {
        categoryTariffTitle.style.marginTop = `${maxHeight}px`;
      }
    } else if (categoryTariffTitle) {
      categoryTariffTitle.style.marginTop = "20px";
    }
  }

  equalizeNameTariffHeight();
  window.addEventListener("resize", equalizeNameTariffHeight);
});
